import { useState } from "react";
import { useTableRowDelete } from "src/hooks/use-table-row-delete";
import Iconify from "src/components/iconify";
import {
  TableRow,
  TableCell,
  IconButton,
  Popover,
  MenuItem,
} from "@mui/material";

export const CustomTableRow = ({
  index,
  row,
  loadRecords,
  deleteUrl,
  tableCells,
  tableMenus,
  deleteMessage,
  showMenu = true,
}) => {
  const [open, setOpen] = useState(null);
  const rowDelete = useTableRowDelete();

  const handleDelete = () => {
    setOpen(false);
    rowDelete({ loadRecords, url: deleteUrl, message: deleteMessage });
  };
  return (
    <>
      <TableRow hover tabIndex={-1} role="checkbox">
        <TableCell padding="normal" width={"10px"}>
          {index}
        </TableCell>
        {tableCells}
        {showMenu && (
          <TableCell align="right" width={"10px"}>
            <IconButton onClick={(e) => setOpen(e.currentTarget)}>
              <Iconify icon="eva:more-vertical-fill" />
            </IconButton>
          </TableCell>
        )}
      </TableRow>
      <Popover
        open={!!open}
        anchorEl={open}
        onClose={() => setOpen(null)}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: { width: 160 },
        }}
      >
        {tableMenus}
        {deleteUrl && (
          <MenuItem onClick={handleDelete} sx={{ color: "error.main" }}>
            <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
            Delete
          </MenuItem>
        )}
      </Popover>
    </>
  );
};
